import { DescontoDSRItem } from '@/service/api/endpoints/dsr'

export type NivelDSR = 'centroCusto' | 'local' | 'funcionario' | 'data'

export const ORDEM_NIVEIS_CLIENTE: readonly NivelDSR[] = [
    'centroCusto',
    'local',
    'funcionario',
] as const

export const ORDEM_NIVEIS_FUNCIONARIO: readonly NivelDSR[] = [
    'centroCusto',
    'local',
    'funcionario',
    'data',
] as const

export const LABEL_NIVEL: Record<NivelDSR, string> = {
    centroCusto: 'Centro de custo',
    local: 'Local',
    funcionario: 'Funcionário',
    data: 'Data',
}

export const CAMPO_POR_NIVEL: Record<NivelDSR, string> = {
    centroCusto: '_centroCustoKey',
    local: '_localKey',
    funcionario: '_funcionarioKey',
    data: '_dataKey',
}

export type { DescontoDSRItem }
